export const NO_MATCHING_CUSTOMER_FOUND = '0';
export const CUSTOMER_EMAIL_NOT_UNIQUE_ERROR_CODE = 'VIOLATION::CUSTOMER_EMAIL_NOT_UNIQUE';
export const CART_PRODUCT_STOCK_REACHED = 'product-stock-reached';
export const CART_INVALID_QUANTITY = 'invalid-quantity';
export const CART_PRODUCT_OUT_OF_STOCK = 'product-out-of-stock';
export const CART_PAYMENT_METHOD_BLOCKED = 'payment-method-blocked';
export const CART_PROMOTION_NOT_APPLICABLE = 'promotion-not-applicable';
export const CART_PROMOTION_NOT_FOUND = 'promotion-not-found';
export const CART_INVALID_PAYMENT_METHOD_SELECTED = 'invalid-payment-method-selection';
export const CHECKOUT__CART_INVALID = 'CHECKOUT__CART_INVALID';
export const CHECKOUT__CART_EMPTY = 'CHECKOUT__CART_EMPTY';
export const CHECKOUT__UNKNOWN_PAYMENT_METHOD = 'CHECKOUT__UNKNOWN_PAYMENT_METHOD';
export const CHECKOUT__CUSTOMER_IS_INACTIVE = 'CHECKOUT__CUSTOMER_IS_INACTIVE';
export const CHECKOUT__CUSTOMER_NOT_FOUND = 'CHECKOUT__CUSTOMER_NOT_FOUND';
